module.exports = __webpack_public_path__ + "img/3.8d6acffb.png";